import { devMode } from '../../util/env'
import { buildQueryString } from '../../util/string'
import { NONCE } from '../../shared/constants'
import { SUBMIT_SUCCESS } from './downloadExpose'

export const REQUEST_DOWNLOAD = 'ksk001/downloadPdf/REQUEST_DOWNLOAD'
export const REQUEST_DOWNLOAD_SUCCESS =
  'ksk001/downloadPdf/REQUEST_DOWNLOAD_SUCCESS'
export const REQUEST_DOWNLOAD_FAILURE =
  'ksk001/downloadPdf/REQUEST_DOWNLOAD_FAILURE'

export const initialState = {
  error: false,
  success: false,
  isSubmitting: false,
}

export default (state = initialState, action) => {
  const { type, payload } = action

  switch (type) {
    case REQUEST_DOWNLOAD:
      return {
        ...state,
        isRequesting: true,
        error: false,
      }
    case REQUEST_DOWNLOAD_SUCCESS:
      return {
        ...state,
        isRequesting: false,
        success: payload.success,
      }
    case REQUEST_DOWNLOAD_FAILURE:
      return {
        ...state,
        isRequesting: false,
        error: payload.error,
      }
    default:
      return state
  }
}

export const requestDownload = id => dispatch => {
  const query = buildQueryString({ id })

  dispatch({
    type: REQUEST_DOWNLOAD,
  })

  return fetch(`/wp-json/dhsv/v1/user/download-pdf?${query}`, {
    headers: {
      'X-WP-Nonce': NONCE,
    },
  })
    .then(response => {
      if (![200, 400].includes(response.status)) {
        const message = response.statusText
          ? response.status + ': ' + response.statusText
          : response.status

        throw new Error(message)
      }

      return response.blob().then(blob => {
        if ('size' in blob) {
          const url = window.URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.href = url
          a.download = 'report.pdf'
          document.body.appendChild(a)
          a.click()
          a.remove()

          dispatch({
            type: SUBMIT_SUCCESS,
            payload: {
              success: 'Download erfolgreich',
            },
          })
        }
      })
    })
    .catch(error => {
      if (devMode) console.error(error) //eslint-disable-line
      dispatch({
        payload: {
          error: error.message,
        },
        type: REQUEST_DOWNLOAD_FAILURE,
      })
      throw error
    })
}
